import React from 'react';
import './Table.css';

import ReactExport from 'react-export-excel';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export default function Table({
  multidimarray,
  osszToke,
  osszKamat,
  osszesFizetendo,
  hitelTermekMegnevezes,
  osszeg,
  futamido,
  turelmiIdo,
  kamat,
}) {
  const formatNumber = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  };

  let tablazat = [];

  for (let i = 0; i < multidimarray[0].length; i++) {
    tablazat.push({
      honap: multidimarray[0][i],
      toke: multidimarray[1][i],
      kamat: multidimarray[2][i],
      oht: multidimarray[3][i],
    });
  }
  tablazat.push({
    honap: 'Összesen:',
    toke: osszToke,
    kamat: osszKamat,
    oht: osszesFizetendo,
  });

  tablazat[0].egyeb = 'Hitel Termék Megnevezése';
  tablazat[0].value = hitelTermekMegnevezes;
  tablazat[1].egyeb = 'Összeg';
  tablazat[1].value = osszeg;
  tablazat[2].egyeb = 'Futamidő';
  tablazat[2].value = futamido;
  tablazat[3].egyeb = 'Türelmi idő';
  tablazat[3].value = turelmiIdo;
  tablazat[4].egyeb = 'Kamat';
  tablazat[4].value = kamat;

  function transpose(a) {
    return Object.keys(a[0]).map(function (c) {
      return a.map(function (r) {
        return r[c];
      });
    });
  }

  return (
    <div>
      <table
        className='table table-hover table-striped table-bordered'
        id='table'
      >
        <thead>
          <th scope='row'>Hónap</th>
          <th scope='row'>Tőke (Ft)</th>
          <th scope='row'>Kamat (Ft)</th>
          <th scope='row'>Összes havi törlesztés (Ft)</th>
        </thead>
        <tbody>
          {transpose(multidimarray).map((x) => (
            <tr>
              {x.map((y) => (
                <td> {formatNumber(y)}</td>
              ))}
            </tr>
          ))}
          <tr>
            <td>
              <b>Összesen:</b>
            </td>
            <td>
              <b>{formatNumber(osszToke)} Ft</b>
            </td>
            <td>
              <b>{formatNumber(osszKamat)} Ft</b>
            </td>
            <td>
              <b>{formatNumber(osszesFizetendo)} Ft</b>
            </td>
          </tr>
        </tbody>
      </table>

      <ExcelFile
        element={
          <button className='btn btn-outline-secondary'>XLS letöltése</button>
        }
      >
        <ExcelSheet data={tablazat} name='Hitelek'>
          <ExcelColumn label='Hónap' value='honap' />
          <ExcelColumn label='Tőke (Ft)	' value='toke' />
          <ExcelColumn label='Kamat (Ft)' value='kamat' />
          <ExcelColumn label='Összes havi törlesztés (Ft)' value='oht' />
          <ExcelColumn label='' value='' />
          <ExcelColumn label='Adatok' value='egyeb' />
          <ExcelColumn label='' value='value' />
        </ExcelSheet>
      </ExcelFile>
    </div>
  );
}
